import { Component } from '@angular/core';
import { LoaderService } from '@app/services/loader.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent {
  constructor(private readonly loaderService: LoaderService) {
    this.loaderService.showNavbarSubject.next(true);
  }
}
